import { useQuery } from 'react-query';
import { CACHE_1_HOUR_MS } from '../../config/utils/cacheUtils';
import { PosSettings, ProviderSettings } from '../../interfaces/company.interface';
import { CustomerVatRegime } from '../../interfaces/customer.interface';
import { DocumentTypeInterface } from '../../interfaces/documentType.interface';
import { DocPurpose, TaxWithhold } from '../../interfaces/invoice.interface';
import { PaymentType } from '../../interfaces/paymentTypes.interface';
import { VatExceptionCategoryInterface } from '../../interfaces/vatExceptionCategory.interface';
import { apiRQ } from '../api';

export interface FormData {
  paymentTypes: PaymentType[];
  pos: PosSettings[];
  providerSettings: ProviderSettings | Record<string, unknown>;
  docTypes: DocumentTypeInterface[];
  mostUsedDocumentTypeId: number | null;
  vatExceptionCategories: VatExceptionCategoryInterface[];
  customerVatRegimes: CustomerVatRegime[];
  docPurposes: DocPurpose[];
  taxWithholds: TaxWithhold[];
}

export const getFormData = async (): Promise<FormData> => {
  const resp = await apiRQ.get<FormData>('/form-data');

  return resp.data;
};

export const useForm = () => {
  return useQuery<FormData, Error>(['useForm'], () => getFormData(), {
    cacheTime: CACHE_1_HOUR_MS,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
};
